<!---
  - Copyright (c) 2022 by 安徽网才信息技术股份有限公司
  -
  - 除非事先获得版权所有人的许可, 禁止以下几项行为:
  - 1. 对该软件的任何源代码和技术文档进行任意形式的打包、分发或复制用于其他目的。
  - 2. 向第三方透露任何与该软件相关的源代码或技术文档。
  - 3. 更改或删除软件或源码中的版权声明。
  -->

<template>
    <div class="error-page">
        <div class="content-con">
            <img
                :src="src"
                :alt="code"
            />
            <div class="text-con">
                <h4>{{ code }}</h4>
                <h5>{{ desc }}</h5>
            </div>
        </div>
    </div>
</template>

<script>
import './error.less';
export default {
    name: 'ErrorContent',
    props: {
        code: String,
        desc: String,
        src: String
    }
};
</script>
